/* eslint-disable import/prefer-default-export */
import { styled } from '@mui/material/styles';

export const DocumentPreview = styled('img')`
	object-fit: contain;
`;
